import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ForwardedRef, ReactNode } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../core';
import { theme } from './dialog_modal.theme';

const StyledDescription = styled(DialogPrimitive.Description)`
	font: ${theme.getValue('descriptionFont')};
	margin: 0;

	${coreTokens.breakpointQuery.medium} {
		font: ${theme.getValue('descriptionFontAtMediumAndAbove')};
	}
`;

export interface DialogModalDescriptionProps {
	children: ReactNode;
}

export function DialogModalDescription({ children }: DialogModalDescriptionProps, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	return <StyledDescription ref={ref}>{children}</StyledDescription>;
}
